import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconWorkflowShapes32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconWorkflowShapes32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M25.672 9 22 5.33 18.328 9 22 12.672zm-2.258-5.086a2 2 0 0 0-2.828 0l-3.672 3.672a2 2 0 0 0-.318.414H13.9A5.002 5.002 0 0 0 4 9a5 5 0 0 0 4 4.9V18H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-2v-4.1a5.01 5.01 0 0 0 3.9-3.9h2.696q.128.224.318.414l3.672 3.672q.191.19.414.318V18.1a5.002 5.002 0 0 0 1 9.9 5 5 0 0 0 1-9.9v-3.696q.224-.128.414-.318l3.672-3.672a2 2 0 0 0 0-2.828zM12 9a3 3 0 1 0-6 0 3 3 0 0 0 6 0m0 17v-6H6v6zm10 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconWorkflowShapes32);
